import { useNavigate, useLocation } from "react-router-dom";
import { useDeviceType } from "hooks/useDeviceType";
import {
  PAGE_PARAMETER,
  PAGE_SIZE_PARAMETER,
} from "helpers/constants/miscellaneous";
import { Pagination } from "./index";

const DESKTOP_ITEMS_LENGTH = 17;
const LAPTOP_ITEMS_LENGTH = 7;

export const useTablePagination = (pagination?: Pagination) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isDesktop } = useDeviceType();
  const pageSize = isDesktop
    ? pagination?.desktopItemsLength || DESKTOP_ITEMS_LENGTH
    : pagination?.laptopItemsLength || LAPTOP_ITEMS_LENGTH;

  const searchParams = new URLSearchParams(location.search);
  const page = Number(searchParams.get(PAGE_PARAMETER)) || 1;

  const navigateToPage = (newPage: number) => {
    const currentParams = new URLSearchParams(window.location.search);
    currentParams.set(PAGE_PARAMETER, newPage.toString());
    currentParams.set(PAGE_SIZE_PARAMETER, pageSize.toString());

    const newSearch = currentParams.toString();

    navigate(
      {
        pathname: location.pathname,
        search: `?${newSearch}`,
      },
      { replace: true },
    );
  };

  return {
    page,
    pageSize,
    navigateToPage,
  };
};
